<template>
  <el-dialog
    class="dialog-wrapper"
    visible
    show-close
    @close="abortSend"
  >
    <ContentHeader
      slot="title"
      :title="$t('signatureProfiles.credentials.title')"
    />
    <ValidationObserver
      ref="recipientForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <el-row
          :gutter="20"
          type="flex"
        >
          <el-col :span="24">
            <FormItem
              rules="required"
              :label="$t('signatureProfiles.credentials.username')"
            >
              <el-input v-model="formData.username" />
            </FormItem>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
        >
          <el-col :span="24">
            <FormItem
              rules="required"
              :label="$t('signatureProfiles.credentials.password')"
            >
              <el-input
                v-model="formData.password"
                show-password
              />
            </FormItem>
          </el-col>
        </el-row>
        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortSend"
          >
            {{ $t('signatureProfiles.credentials.abort') }}
          </el-button>
          <el-button
            type="primary"
            native-type="submit"
            :disabled="invalid"
            @click.prevent="handleSubmit(sendCredentials)"
          >
            {{ $t('signatureProfiles.credentials.send') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { signatureProfilesApi } from '@/api';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormItem from '@/components/FormItem.vue';
  import FormButtons from '@/components/FormButtons.vue';

  const defaultData = {
    username: '',
    password: '',
  };

  export default {
    name: 'SendCredentialsModal',
    components: {
      ContentHeader,
      FormItem,
      FormButtons,
    },
    props: {
      profileId: { type: String, default: null },
    },
    data() {
      return {
        formData: { ...defaultData },
      };
    },
    methods: {
      abortSend() {
        this.$emit('dialogClose', { success: false });
      },
      async sendCredentials() {
        const { username, password } = this.formData;
        const data = {
          signatureAccountId: username,
          signaturePassword: password,
        };
        try {
          await signatureProfilesApi.patch(this.profileId, data);
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('signatureProfiles.credentials.success'),
          });
          this.$emit('dialogClose', { success: true });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
    },
  };
</script>
